import { APP_ROOT, PC_SERVICE_ADDRESS } from "./configurations";

export const API_ROOT = `api`; // `${APP_ROOT}/api`;
export const API_SERVER = `${PC_SERVICE_ADDRESS}/api`;
export const API_CONCENTRATOR = `${API_ROOT}/concentrator`;
export const API_SYSTEM_LOG = `${API_ROOT}/completelog`;
export const API_MANUAL_CONTROL = `${API_CONCENTRATOR}/manual-control`;
export const API_DEVICE = `${API_ROOT}/device`;
export const API_CUSTOM_OPERATIONS = `${API_DEVICE}/custom-operations`;
export const API_PRESSURE_CONTROLLER = `${API_DEVICE}/pressure-controller`;
/**
 * @deprecated
 */
export const API_VOLUME_SENSOR = `${API_ROOT}/volume-sensor`;
export const API_LOAD_CELL = `${API_ROOT}/volume-sensor/load-cell`;
export const API_DEV = `${APP_ROOT}/dev-api`;
export const API_CONFIGURATION = `${API_ROOT}/configuration`;
export const API_SYSTEM = `${API_ROOT}/system`;
export const API_WIFI = `${API_ROOT}/wifi`;
export const API_UPDATE = `${API_ROOT}/update`;

// config
export const CONCENTRATOR_LOCK = `${API_CONCENTRATOR}/lock`;
export const GET_CONFIGURATION = API_CONFIGURATION;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const PUT_CONFIGURATION = API_CONFIGURATION;
export const GET_DEFAULT_CONFIGURATION = `${API_CONFIGURATION}/default`;
export const GET_STATUS = `${API_ROOT}/status`;
export const GET_INFO = `${API_SYSTEM}/info`;
export const POST_SAVE_CONFIGURATION = `${API_DEVICE}/configuration/save`;
// Temperature
/**
 * @deprecated
 */
export const STEINHART_TEMPERATURE_PARAM = `${API_DEVICE}/temperature/steinhart-temperature-param`;
/**
 * @deprecated
 */
export const TEMPERATURE_COPENSATED_PARAM = `${API_DEVICE}/temperature/temperature-compensated-param`;
/**
 * @deprecated
 */
export const TEMPERATURE_SENSOR_OFFSET = `${API_DEVICE}/temperature/temperature-sensor-offset`;
/**
 * @deprecated
 */
export const TEMPERATURE_SENSOR = `${API_DEVICE}/sensor/temperature`;
// device element
export const DEVICE_ELEMENT_AVAILABILITY = `${API_DEVICE}/sensor/availability-component`;
export const RAW_DATA_VOLUME_SENSOR = `${API_DEVICE}/volume-sensor/raw-data-value`;
export const GET_PUMP_COUNTER = `${API_DEVICE}/pump-counter`;
export const GET_VALVE = `${API_DEVICE}/valves/`;
/**
 * @deprecated
 */
export const PUT_VALVE = `${API_DEVICE}/valves/`;

export const API_PROFILE = `${API_ROOT}/profiles`;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const GET_PROFILE_LIST = API_PROFILE;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const DELETE_PROFILE = API_PROFILE;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const POST_RENAME_PROFILE = API_PROFILE;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const POST_PROFILE_DETAIL = API_PROFILE;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const POST_CREATE_PROFILE = `${API_PROFILE}/create`;
/**
 * @deprecated current software version (since 2019) only applying for one time usage
 */
export const PUT_EDIT_PROFILE = `${API_PROFILE}/edit`;

// ManualControl
export const ENABLE_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/enable`;
export const START_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/start`;
/**
 * @deprecated because the manual control flow can be back forward from recovery or vice versa
 */
export const STOP_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/stop`;
export const RECOVERY_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/recovery/start`;
export const STOP_RECOVERY_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/recovery/stop`;
export const CANCEL_MANUAL_CONTROL = `${API_MANUAL_CONTROL}/break`;
export const START_HOLD_TO_CONCENTRATE = `${API_CONCENTRATOR}/hold-concentrate/start`;
export const STOP_HOLD_TO_CONCENTRATE = `${API_CONCENTRATOR}/hold-concentrate/stop`;

// PreCheckProfile
/**
 * @deprecated
 */
export const START_VOLUME_MONITORING = `${API_VOLUME_SENSOR}/start-volume-monitoring`;
/**
 * @deprecated
 */
export const STOP_VOLUME_MONITORING = `${API_VOLUME_SENSOR}/stop-volume-monitoring`;
export const RESET_VOLUME_MONITORING = `${API_VOLUME_SENSOR}/reset-volume-monitoring`;
export const SET_HIGH_VOLUME_BUFFER = `${API_CONCENTRATOR}/set-high-volume-buffer`;

// ADV SETUP
export const API_ADV_SETUP = `${API_ROOT}/advsetups`;
export const GET_DEFAULT_ADV_SETUP = `${API_CONFIGURATION}/advsetups/default`;
export const GET_DEFAULT_ADV_SETUP_NEW = `${API_ADV_SETUP}/default`;
export const POST_CREATE_ADV_SETUP = `${API_ADV_SETUP}/create`;
export const PUT_EDIT_ADV_SETUP = `${API_ADV_SETUP}/edit`;
export const GET_ADV_SETUP_LIST = API_ADV_SETUP;
export const DELETE_ADV_SETUP = API_ADV_SETUP;
export const POST_RENAME_ADV_SETUP = API_ADV_SETUP;
export const POST_ADV_SETUP_DETAIL = API_ADV_SETUP;
export const CREATE = "/create";

export const POST_DEV_PRIMING_START = `${API_DEV}/priming/start`;
export const POST_DEV_PRIMING_STOP = `${API_DEV}/priming/stop`;
export const POST_DEV_CONCENTRATING_START = `${API_DEV}/concentrating/start`;
export const POST_DEV_CONCENTRATING_STOP = `${API_DEV}/concentrating/stop`;
export const POST_DEV_DIAFILTRATION_DISCRETE_START = `${API_DEV}/diafiltration/start`;
export const POST_DEV_DIAFILTRATION_DISCRETE_STOP = `${API_DEV}/diafiltration/stop`;
export const POST_DEV_DIAFILTRATION_CONTINUOUS_START = `${API_DEV}/diafiltration/start`;
export const POST_DEV_DIAFILTRATION_CONTINUOUS_STOP = `${API_DEV}/diafiltration/stop`;

// sensor value :
export const GET_ALL_SENSOR = `${API_DEV}/devicetest/sensor-params`;
export const VOLUME_SENSOR_ROW_VALUES = `${API_VOLUME_SENSOR}/row-value`;

export const API_HARDWARE_CHECK_UP = `${API_ROOT}/hardware-check`;
export const POST_START_HARDWARE_CHECK_UP = `${API_HARDWARE_CHECK_UP}/start`;
export const POST_RESUME_HARDWARE_CHECK_UP = `${API_HARDWARE_CHECK_UP}/resume`;
export const POST_PAUSE_HARDWARE_CHECK_UP = `${API_HARDWARE_CHECK_UP}/pause`;
export const POST_CANCEL_HARDWARE_CHECK_UP = `${API_HARDWARE_CHECK_UP}/cancel`;
export const GET_STATUS_HARRDWARE_CHECK_UP = `${API_HARDWARE_CHECK_UP}/status`;

/**
 * @deprecated
 */
export const POST_CONNECT_SERIAL = `${API_DEVICE}/connect`;
/**
 * @deprecated
 */
export const POST_DISCONNECT_SERIAL = `${API_DEVICE}/disconnect`;
/**
 * @deprecated
 */
export const GET_STATUS_SERIAL = `${API_DEVICE}/status`;
export const POST_SHUT_DOWN = `${API_DEVICE}/shutdown`;
export const POST_RESTART = `${API_DEVICE}/restart`;

// Update
export const CHECK_UPDATE_VERSION = `${API_UPDATE}/check-version`;
export const DOWNLOAD_UPDATE = `${API_UPDATE}/download`;
export const STATUS_DOWNLOAD_UPDATE = `${API_UPDATE}/download/status`;
export const CANCEL_DOWNLOAD_UPDATE = `${API_UPDATE}/download/cancel`;
export const INSTALL_UPDATE = `${API_UPDATE}/install-update/software`;
export const STATUS_INSTALL_UPDATE = `${API_UPDATE}/install-status`;

export const POST_SYSTEM_UPDATE = `${API_SYSTEM}/update`;
export const POST_CHECK_SOFTWARE_VERSION = `${API_SYSTEM}/check`;
export const POST_CANCEL_UPDATE = `${API_SYSTEM}/cancel-update`;
export const GET_STATUS_UPDATE = `${API_SYSTEM}/status-update`;
export const POST_INSTALL_OFFLINE_UPDATE_SOFTWARE = INSTALL_UPDATE;
export const POST_UPDATE_OFFLINE_SOFTWARE = `${API_UPDATE}/manual-update/software`;
export const RELEASE_NOTE = `${API_UPDATE}/release-notes`;
export const CANCEL_UPDATE = `${API_UPDATE}/cancel-update`;

// firmware Pressure controller setting
/**
 * @deprecated
 */
export const PUT_PRESSURE_CONTROL = `${API_PRESSURE_CONTROLLER}/params/`;
export const GET_PRESSURE_CONTROLER = `${API_PRESSURE_CONTROLLER}/params/`;
/**
 * @deprecated
 */
export const PUT_PRESSURE_CONTROL_DEBUG = `${API_PRESSURE_CONTROLLER}-debug/params/`;
/**
 * @deprecated
 */
export const PRESSURE_CONTROLER = `${API_PRESSURE_CONTROLLER}/params`;
/**
 * @deprecated
 */
export const PRESSURE_STATE = `${API_PRESSURE_CONTROLLER}/state/`;
/**
 * @deprecated
 */
export const PRESSURE_SENSOR = `${API_PRESSURE_CONTROLLER}/sensors/`;

// cycle pressure controller
export const CYCLE_PARAM = `${API_DEVICE}/cycle-param`;
export const DEFAULT_CYCLE_PARAM = `${API_DEVICE}/cycle-param/default`;

// Display Settings
export const DISPLAY_SETTINGS = `${API_SYSTEM}/display-settings`;
export const SAMBA_USER = `${API_ROOT}/sambauser`;

// Wifi Settings
export const POST_WIFI_ON_OFF = API_WIFI;
export const GET_IS_WIFI_AVAILABLE = `${API_WIFI}/IsWifiAvailable`;
export const GET_IS_WIFI_CONNECTED = `${API_WIFI}/isconnected`;
export const GET_LIST_WIFI = `${API_WIFI}/GetListAPs`;
export const POST_CONNECT_TO_WIFI = `${API_WIFI}/Connect`;
export const POST_DISCONNECT_FROM_WIFI = `${API_WIFI}/Disconnect`;
export const POST_FORGET_WIFI = `${API_WIFI}/Forget`;

// Return Device Version
export const GET_DEVICE_VERSION = `${API_SERVER}/firmware/getHardwareVersion`;

// Return Valve Pressure Settings
export const GET_FACTORY_DEFAULT_RETURN_VALVE = `${API_ROOT}/ReturnValvePressure/factory-default`;
export const GET_RETURN_VALVE_PRESSURE_SETTINGS = `${API_ROOT}/ReturnValvePressure/default`;
export const PUT_RETURN_VALVE_PRESSURE_SETTINGS = `${API_ROOT}/ReturnValvePressure/update`;

export const GET_FACTORY_DEFAULT_VOLUME_THRESHOLD = `${API_ROOT}/FlowRateThreshold/factory-default`; // "/api/volume-change-threshold/factory-default";
export const GET_VOLUME_THRESHOLD_SETTINGS = `${API_ROOT}/FlowRateThreshold/default`;
export const PUT_VOLUME_THRESHOLD_SETTINGS = `${API_ROOT}/FlowRateThreshold/update`;

// USB Drive
/**
 * @deprecated
 */
export const GET_FILE_LIST = `${API_DEVICE}/file-list`;
export const API_USB_DRIVE = `${API_DEVICE}/usbdrive`;
export const GET_USB_DRIVE = API_USB_DRIVE;
/**
 * @deprecated
 */
export const POST_MOUNT_FLASH_DRIVE = `${API_USB_DRIVE}/mount`;
/**
 * @deprecated
 */
export const POST_UNMOUNT_FLASH_DRIVE = `${API_USB_DRIVE}/unmount`;
// API parameter path of the usb drive or root folder, level of the structure (-1 for get all level, 0 for 1 child level. default is 0)
// var params = {
// 	path: path,
// 	level: -1,
// };
export const GET_FOLDER_STRUCTURE = `${API_USB_DRIVE}/structure`; // localhost:9000/api/device/usbdrive/structure?path=E:&level=2
export const GET_SOFTWARE_UPDATE_FILE_LIST = `${API_USB_DRIVE}/update`;
export const GET_LICENSE_FILE_LIST = `${API_USB_DRIVE}/license`;
// cleaning wizard
export const POST_START_CLEANIG_WIZARD = `${API_DEVICE}/cleaning-operations/start`;
export const POST_STOP_CLEANIG_WIZARD = `${API_DEVICE}/cleaning-operations/stop`;
export const GET_STATUS_CLEANING_WIZARD = `${API_DEVICE}/cleaning-operations/status`;

// cycle history
export const GET_CYCLE_HISTORY_LIST = `${API_CONCENTRATOR}/history/list`;
export const GET_CYCLE_HISTORY_DETAIL = `${API_CONCENTRATOR}/history/detail`;
export const POST_EXPORT_CYCLE_HISTORY = `${API_CONCENTRATOR}/history/export`;
export const POST_EXPORT_MULTIPLE_CYCLE_HISTORY = `${API_CONCENTRATOR}/histories/export`;

// system log
export const POST_SAVE_SYSTEM_LOG = `${API_SYSTEM_LOG}/log/save`;
export const GET_SYSTEM_LOG = `${API_SYSTEM_LOG}/log/export`;

// Device Properties
export const POST_DEVICE_SETTING = `${API_SYSTEM}/set-systemsetting`;
export const POST_DEVICE_NAME = `${API_SYSTEM}/device-name`;
export const POST_DATE_TIME = `${API_SYSTEM}/date-time`;
export const POST_DEVICE_ORGANITATION = `${API_SYSTEM}/device-organitation`;
export const GET_DEVICE_PROPERTIES = `${API_SYSTEM}/device-properties`;
export const GET_HARDWARE_PROPERTIES = `${API_SYSTEM}/hardawre-properties`;
export const POST_TIME_ZONE = `${API_SYSTEM}/set-timezone`;
export const GET_TIME_ZONE = `${API_SYSTEM}/get-timezone`;
export const GET_LIST_TIME_ZONE_AREA = `${API_SYSTEM}/getlist-timezonearea`;
export const POST_LIST_TIME_ZONE_REGION = `${API_SYSTEM}/getlist-timezoneregion`;
export const POST_SET_AUTO_TIMEZONE = `${API_SYSTEM}/set-autotimezone`;
export const POST_SET_AUTO_DATETIME = `${API_SYSTEM}/set-autodatetime`;
export const GET_AUTO_TIMEZONE = `${API_SYSTEM}/get-autotimezone`;
export const GET_AUTO_DATETIME = `${API_SYSTEM}/get-autodatetime`;
export const GET_TIMEZONE_FROM_SERVER = `${API_SYSTEM}/get-timezone-fromserver`;
export const GET_DATETIME_FROM_SERVER = `${API_SYSTEM}/get-datetime-fromserver`;
export const GET_DATETIME_FROM_LOCAL = `${API_SYSTEM}/get-datetime-fromlocal`;
export const GET_DATETIME = `${API_SYSTEM}/date-time`;

// loadcell
export const GET_ALL_SENSOR_VALUE = `${API_DEVICE}/all/sensorvalue`;
/**
 * @deprecated
 */
export const LOAD_CELL_FIRMWARE_CONFIG = `${API_LOAD_CELL}/configuration`;
export const CALIBRATE_LOAD_CELL = `${API_LOAD_CELL}/calibrate-loadcell/`;
export const IS_BOTTLE_PROTEIN_ATTACHED = `${API_LOAD_CELL}/IsBottleProteinAttached`;
export const IS_BOTTLE_BUFFER_ATTACHED = `${API_LOAD_CELL}/IsBottleBufferAttached`;
export const IS_TUBE_SENSOR_AVAILABLE = `${API_LOAD_CELL}/IsTubeSensorAvailable`;
export const TARE = `${API_LOAD_CELL}/tare`;
export const TARE_REFERENCE = `${API_LOAD_CELL}/tare-reference`;
export const IS_FIRST_TARE_ENABLE = `${API_LOAD_CELL}/is-tared`;
export const IS_DONE = "/IsDone";
export const CANCEL_CALIBRATION = `${API_LOAD_CELL}/CancelCalibration`;
export const DO_TARE = `${API_LOAD_CELL}/do-tare`;
export const IS_CALIBRATION_REQUIRED = `${API_LOAD_CELL}/IsCalibrationRequired`;

// Calibrtion History loadcell
export const GET_CALIBRATION_HISTORY = `${API_LOAD_CELL}/GetHistory`;
export const CALIBRATION_FACTORY_RESET = `${API_LOAD_CELL}/FactoryReset`;
export const CALIBRATE_FROM_HISTORY = `${API_LOAD_CELL}/CalibrateFromHistory`;
export const SAVE_CALIBRATION = `${API_LOAD_CELL}/SaveCalibration`;
export const DELETE_HISTORY = `${API_LOAD_CELL}/DeleteHistory`;

// warmingUp
export const WARMING_UP_STATUS = `${API_ROOT}/warming-up/status`;
export const WARMING_UP_CONFIG = `${API_ROOT}/warming-up/config`;
export const WARMING_UP_VIDEO = `${API_ROOT}/warming-up/video`;
export const WARMING_UP_STOP_VIDEO = `${API_ROOT}/warming-up/video/stop`;

// License
export const POST_INITIAL_LICENSE = `${API_ROOT}/license/`;
export const GET_LICENSE_INFO = `${POST_INITIAL_LICENSE}GetLicenseInfo`; // GET http://localhost:5002/api/License/GetLicenseInfo
export const POST_ACTIVATE_LICENSE_TRIAL = `${POST_INITIAL_LICENSE}ActivateTrialLicense`; // POST  http://localhost:5002/api/License/ActivateTrialLicense?clientName=Formulatrix
export const POST_ACTIVATE_LICENSE_MANUAL = `${POST_INITIAL_LICENSE}ActivateLicenseManually`; // POST http://localhost:5002/api/License/ActivateLicenseManually
export const GET_IS_TRIAL_LICENSE_AVAILABLE = `${POST_INITIAL_LICENSE}IsTrialLicenseActivated`; // GET http://localhost:5002/api/License/IsTrialLicenseActivated

// Process Auto Profile
export const POST_START_PROTEIN_CONCENTRATOR = `${API_CONCENTRATOR}/start`;
export const POST_STOP_PROTEIN_CONCENTRATOR = `${API_CONCENTRATOR}/stop`;
export const POST_PAUSE_PROTEIN_CONCENTRATOR = `${API_CONCENTRATOR}/pause`;
export const POST_RESUME_PROTEIN_CONCENTRATOR = `${API_CONCENTRATOR}/resume`;
export const RESUME_VOLUME_THRESHOLD_ERROR = `${API_CONCENTRATOR}/volume-threshold-error/resume`;
export const POST_START_AUTO_PROTEIN_CONCENTRATOR = `${API_CONCENTRATOR}/new-auto/start`;
export const POST_REFILLED_BUFFER = `${API_CONCENTRATOR}/diafiltration/refill-buffer`;
export const POST_CANCEL_REFILLED_BUFFER = `${API_CONCENTRATOR}/diafiltration/cancel-refill-buffer`;

// ManualProfile
export const GET_STATUS_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/status`;
export const POST_START_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/start`;
export const POST_STOP_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/stop`;
export const POST_PAUSE_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/pause`;
export const POST_RESUME_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/resume`;

export const POST_SAVE_SEQUENCE = `${API_CUSTOM_OPERATIONS}/savesequence`;
export const POST_DELETE_SEQUENCE = `${API_CUSTOM_OPERATIONS}/deletesequence`;
export const POST_DETAIL_SEQUENCE = `${API_CUSTOM_OPERATIONS}/getdetailsequence`;
export const GET_LIST_SEQUENCE = `${API_CUSTOM_OPERATIONS}/getlistsequences`;
export const POST_RENAME_SEQUENCE = `${API_CUSTOM_OPERATIONS}/renamesequence`;
export const POST_SEARCH_SEQUENCE = `${API_CUSTOM_OPERATIONS}/manual-profile/search`;
/**
 * @deprecated
 */
export const DELETE_PROFILE_SEQUENCE_DESIGNER = `${API_CUSTOM_OPERATIONS}/`;
/**
 * @deprecated
 */
export const GET_LIST_PROFILE_SEQUENCE_DESIGNER = API_CUSTOM_OPERATIONS;
/**
 * @deprecated
 */
export const POST_ADD_PROFILE_SEQUENCE_DESIGNER = API_CUSTOM_OPERATIONS;

// volume sensor
export const GET_TUBE_EXIST = `${API_VOLUME_SENSOR}/tubes`;
/**
 * @deprecated
 */
export const GET_AVERAGE_CAPACITANCES = `${API_VOLUME_SENSOR}/average-capacitances`;
/**
 * @deprecated
 */
export const RECALULATE_PROTEIN_SENSOR = `${API_VOLUME_SENSOR}/recalculate-protein`;
/**
 * @deprecated
 */
export const RECALULATE_BUFFER_SENSOR = `${API_VOLUME_SENSOR}/recalculate-buffer`;
/**
 * @deprecated
 */
export const VOLUME_SENSOR_CONFIG = `${API_VOLUME_SENSOR}/configuration`;

// Debug page
/**
 * @deprecated
 */
export const POST_COUNT_ABC_CONSTANT_PROTEIN = `${API_VOLUME_SENSOR}/count-protein-abc-constant`;
/**
 * @deprecated
 */
export const POST_COUNT_ABC_CONSTANT_BUFFER = `${API_VOLUME_SENSOR}/count-buffer-abc-constant`;

// configuration
export const HARDWARE_CONFIGURATION = `${API_CONFIGURATION}/hardware-assignment`;

// volume sensor
/**
 * @deprecated
 */
export const URL_VOLUME_CALCULATION = `${API_VOLUME_SENSOR}/volume-calculation-log`;
/**
 * @deprecated
 */
export const URL_VOLUME_CALCULATION_LOG_STATUS = `${API_VOLUME_SENSOR}/volume-calculation-log-status`;
/**
 * @deprecated
 */
export const URL_VOLUME_MONITORING_START = `${API_VOLUME_SENSOR}/start-volume-monitoring`;
/**
 * @deprecated
 */
export const URL_VOLUME_MONITORING_STOP = `${API_VOLUME_SENSOR}/stop-volume-monitoring`;
/**
 * @deprecated
 */
export const URL_VOLUME_MONITORING_STATUS = `${API_VOLUME_SENSOR}/tubes-sensor-ready`;

// liquid level
export const PUT_LIQUID_LEVEL_PARAM = `${API_DEVICE}/liquid-level/params`;
export const PUT_LIQUID_LEVEL_PARAM_LOW = `${API_DEVICE}/liquid-level/low-volume-params`;

export const PCServiceAPI = {
  Device: {
    REBOOT: `${PC_SERVICE_ADDRESS}/api/device/reboot`,
  },
};

export const API_REMOTE_SUPPORT = {
  POST_START_REMOTE_SUPPORT: `${PC_SERVICE_ADDRESS}/api/remote/StartRemoteSession`,
  POST_STOP_REMOTE_SUPPORT: `${PC_SERVICE_ADDRESS}/api/remote/EndRemoteSession`,
  GET_REMOTE_SUPPORT_SESSION: `${PC_SERVICE_ADDRESS}/api/remote/GetRemoteSessionStatus`,
  GET_REMOTE_SUPPORT_DEVICE_STATUS: `${PC_SERVICE_ADDRESS}/api/remote/GetDeviceStatus`,
};

// Mixing feature
export const MIXING = `${API_CONCENTRATOR}/mixing`;
export const START_MIXING = `${MIXING}/start`;
export const STOP_MIXING = `${MIXING}/stop`;

// ----------------- DEVICE API MODULE
/**
 * @enum {String}
 */
export const DEVICE_API_MODULE = {
  UI_ERROR_REPORT: `${API_DEVICE}/ui-error-report`,
};

/**
 * available hub of signalr end point access
 * @enum {String}
 */
export const SIGNAL_R_HUB = {
  DEVICE_HUB: `${APP_ROOT}/devicehub`,
};

/**
 * available method or event of Device Hub
 * @enum {String}
 */
export const DEVICE_HUB_EVENT = {
  OnStateChange: "OnStateChange",
  ManualProfileUpdated: "ManualProfileUpdated",
  CleaningProfileUpdated: "CleaningProfileUpdated",
  OnDeviceFailure: "OnDeviceFailure",
  OnRecoveryStatusUpdated: "OnRecoveryStatusUpdated",
  OnAutoProfileUpdated: "OnAutoProfileUpdated",
  OnCycleTimesUpdated: "OnCycleTimesUpdated",
  OnManualControlStatusUpdated: "OnManualControlStatusUpdated",
  OnDiafiltrationStatusUpdated: "OnDiafiltrationStatusUpdated",
  OnVolumeThresholdError: "OnVolumeThresholdError",
  OnLicenseExpired: "OnLicenseExpired",
  OnDelayProfilePreparation: "OnDelayProfilePreparation",
  OnDelayProfileStart: "OnDelayProfileStart",
  OnDeviceLockUpdated: "OnDeviceLockUpdated",
};
